module.exports = __webpack_public_path__ + "img/9.2c177316.png";